import { createFileRoute } from '@tanstack/react-router'
import { absenceSearchSchema } from '@/features/filter-absence/model/absenceSearch'
import { AbsencePage } from '@/pages/absence/ui/AbsencePage'

export const Route = createFileRoute('/absence')({
  validateSearch: absenceSearchSchema,
  component: AbsencePage,
})
